// extracted by mini-css-extract-plugin
export default {"round":"Round_round__liSK7","nav-button":"Round_nav-button__lg0yq","error":"Round_error__UPRzR","round-info":"Round_round-info__E0lse"};